module.exports = __webpack_public_path__ + "img/icon_refresh.c69621f1.svg";